module.exports={"Clear search":"Очистити пошук"};